import { MessageCircle, Phone } from "lucide-react";
import { BRAND } from "@/lib/site";

export default function FloatingContact() {
  return (
    <>
      <a
        data-testid="floating-whatsapp-button"
        href={BRAND.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-50 hidden md:block"
      >
        <span className="absolute inset-0 animate-pulse-ring rounded-full bg-wa" />
        <span className="relative grid h-14 w-14 place-items-center rounded-full bg-wa text-plum-950 shadow-[0_10px_35px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110">
          <MessageCircle className="h-6 w-6" />
        </span>
      </a>

      <div
        data-testid="mobile-contact-bar"
        className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-white/10 bg-plum-950/95 backdrop-blur-xl md:hidden"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <a
          data-testid="mobile-call-button"
          href={BRAND.callLink}
          className="flex items-center justify-center gap-2 py-4 text-sm font-bold text-champagne"
        >
          <Phone className="h-4 w-4" />
          Call Now
        </a>
        <a
          data-testid="mobile-whatsapp-button"
          href={BRAND.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-wa py-4 text-sm font-bold text-plum-950"
        >
          <MessageCircle className="h-4 w-4" />
          WhatsApp
        </a>
      </div>
    </>
  );
}
